import React from "react";

const WhyBecomeSeller = () => {

 
  return (
    <section className='why-seller py-80'>
      <div className='container'>
        <div className='section-heading text-center mx-auto'>
          <h5 className=''>Why become a seller on Blink Buy?</h5>
          <span className='text-gray-600'>
            Start your dropshipping business with zero inventory risk and minimal upfront investment.
          </span>
        </div>
        <div className='row gy-4 justify-content-center'>
          <div className='col-lg-4 col-sm-6'>
            <div className='why-seller-item text-center'>
              <span className='text-main-600 text-72 d-inline-flex'>
                <i className='ph ph-package' />
              </span>
              <h6 className='my-28'>No Inventory Required</h6>
              <p className='text-gray-600 max-w-392 mx-auto'>
                Sell products without purchasing or storing inventory. Suppliers handle all warehousing and shipping directly to your customers.
              </p>
            </div>
          </div>
          <div className='col-lg-4 col-sm-6'>
            <div className='why-seller-item text-center'>
              <span className='text-main-600 text-72 d-inline-flex'>
                <i className='ph ph-globe' />
              </span>
              <h6 className='my-28'>Access Global Markets</h6>
              <p className='text-gray-600 max-w-392 mx-auto'>
                Source millions of products from Amazon, AliExpress, Alibaba, Walmart, and eBay. Reach customers worldwide with diverse product offerings.
              </p>
            </div>
          </div>
          <div className='col-lg-4 col-sm-6'>
            <div className='why-seller-item text-center'>
              <span className='text-main-600 text-72 d-inline-flex'>
                <i className='ph ph-chart-line-up' />
              </span>
              <h6 className='my-28'>Scale at Your Pace</h6>
              <p className='text-gray-600 max-w-392 mx-auto'>
                Start small and grow your business with automated tools, real-time analytics, and comprehensive support from our platform.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyBecomeSeller;
